var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStyledCheckFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40706",
    "data-name": "Group 40706",
    transform: "translate(20549 18596)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15457",
    "data-name": "Rectangle 15457",
    width: 16,
    height: 16,
    transform: "translate(-20549 -18596)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_3-Check",
    "data-name": "3-Check",
    transform: "translate(-20580 -18645.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36972",
    "data-name": "Path 36972",
    d: "M36.561,63.862a.307.307,0,0,1-.265-.152c-1.148-1.955-4.206-6.116-4.236-6.158a.307.307,0,0,1,.032-.4l.94-.929a.307.307,0,0,1,.392-.033L36.5,58.337a37.958,37.958,0,0,1,5.191-5.505,19.223,19.223,0,0,1,2.326-1.757.307.307,0,0,1,.158-.044h1.521a.307.307,0,0,1,.2.536,43.358,43.358,0,0,0-6.168,7.521c-1.706,2.525-2.89,4.6-2.9,4.619a.307.307,0,0,1-.265.155Z",
    fill: "#06a77d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyledCheckFilled);
export default __webpack_public_path__ + "static/media/styled-check-filled.e99dd2f081998e6a6bd6f2d8962c820e.svg";
export { ForwardRef as ReactComponent };